import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';
import { PlhReportDetails } from '@core/models/api/response/uw-reports-response.model';

@Component({
    selector: 'nwx-plh-report-details',
    templateUrl: './plh-report-details.component.html',
    styleUrls: ['./plh-report-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PlhReportDetailsComponent implements OnInit {
  @Input() reportDetails!: PlhReportDetails[];

  constructor() {}

  ngOnInit(): void {}
}
